import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=cc71d516&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"
import style0 from "./ClientDetails.vue?vue&type=style&index=0&id=cc71d516&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc71d516",
  null
  
)

export default component.exports